export default __webpack_public_path__ + "static/media/3.47a6195b.jpg";